import { getFeaturedArticles } from '@/mocks/articles';
import ArticleCard from '@/components/base/ArticleCard';

export default function FeaturedContent() {
  const featured = getFeaturedArticles();

  return (
    <section className="w-full px-4 md:px-6 py-14 md:py-20">
      <div className="mb-10">
        <div className="flex items-center gap-3 mb-3">
          <div className="w-1 h-5 bg-accent-500 rounded-full"></div>
          <span className="text-accent-400 text-sm font-medium uppercase tracking-wider">精选推荐</span>
        </div>
        <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-50">
          重磅<span className="text-primary-400">推荐</span>
        </h2>
        <p className="text-foreground-400 text-sm mt-2">编辑部精心挑选，每一部都值得细细品味</p>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
        {featured.slice(0, 1).map((article) => (
          <div key={article.id} className="sm:col-span-2 lg:col-span-1">
            <ArticleCard article={article} size="large" />
          </div>
        ))}
        {featured.slice(1, 4).map((article) => (
          <ArticleCard key={article.id} article={article} size="medium" />
        ))}
      </div>
    </section>
  );
}